import React from 'react'

const ZoomChatIcon = ({ style, onClickCb = () => { } }) => {
    return (
        <svg style={style} onClick={onClickCb} id="Component_2281_5" data-name="Component 2281 – 5" xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 40 40">
            <g id="Group_93495" data-name="Group 93495" transform="translate(-10180 4581)">
                <g id="Group_93494" data-name="Group 93494">
                    <g id="Ellipse_1315" data-name="Ellipse 1315" transform="translate(10180 -4581)" fill="#fff" stroke="#aaa" strokeWidth="1" opacity="0">
                        <circle cx="20" cy="20" r="20" stroke="none" />
                        <circle cx="20" cy="20" r="19.5" fill="none" />
                    </g>
                    <g id="chat_black_24dp_2_" data-name="chat_black_24dp (2)" transform="translate(10188 -4573)">
                        <path id="Path_206778" data-name="Path 206778" d="M0,0H24V24H0Z" fill="none" />
                        <path id="Path_206779" data-name="Path 206779" d="M4,4H20V16H5.17L4,17.17V4M4,2A2,2,0,0,0,2.01,4L2,22l4-4H20a2.006,2.006,0,0,0,2-2V4a2.006,2.006,0,0,0-2-2ZM6,12h8v2H6ZM6,9H18v2H6ZM6,6H18V8H6Z" fill="#fff" />
                    </g>
                </g>
            </g>
        </svg>
    )
}

export default ZoomChatIcon
